import PropTypes from 'prop-types'

const IconList = ({ items }) => (
  <ul className="w-full">
    {items.map((item, index) => (
      <li key={index} className="flex text-content2-foreground items-center py-2 pb-2 border-dotted [&:not(:last-child)]:border-b-1">
        <div className='flex items-center'>
          <div className="w-10 mr-4 text-indigo-800 dark:text-content2-foreground">
            {item.icon}
          </div>
          
          <div>
            <p className="text-sm">{item.caption}</p>
            <p className='font-semibold text-content1-foreground'>{item.value}</p>
          </div>
        </div>
      </li>
    ))}
  </ul>
)

IconList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      caption: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
}

export default IconList